import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import Header from "../comm/Header";

function Intro() {
    const dispatch = useDispatch();
    const [bottomTxtAnimation01, setBottomTxtAnimation01] = useState(null);
    const [bottomTxtAnimation02, setBottomTxtAnimation02] = useState(null);
    const [bottomTxtAnimation03, setBottomTxtAnimation03] = useState(null);

    const onVisibilityChangeText01 = (isVisible) => {
        if (isVisible) {
            setBottomTxtAnimation01("1");
        }
    };

    const onVisibilityChangeText02 = (isVisible) => {
        if (isVisible) {
            setBottomTxtAnimation02("1");
        }
    };

    const onVisibilityChangeText03 = (isVisible) => {
        if (isVisible) {
            setBottomTxtAnimation03("1");
        }
    };

    useEffect(
        () => {
            dispatch({ type: "loadingChange", payload: true });

            setTimeout(() => {
                dispatch({ type: "loadingChange", payload: false });
            }, 500);
        },
        // eslint-disable-next-line
        []
    );

    return (
        <>
            <section className="section intro">
                <Header page="sub" />

                <div className="container mt-7">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="text-white">회사소개</h2>
                            <p className="text-white pt-3">회사소개 &gt; 회사소개</p>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container">
                <div className="row pt-99 pb-9">
                    <div className="col-12">
                        <h2>성공 정비업의 시작!</h2>
                        <h4 className="pt-2">탁월한 솔루션 선택이 성공경영을 만듭니다.</h4>

                        <p className="pt-7 animated animatedFadeInUp fadeInUp">
                            <ul>
                                <li>
                                    <span className="text-bold sub-contents-line-height pr-2">
                                        회사명칭 :
                                    </span>
                                    ㈜인트라밴
                                </li>
                                <li>
                                    <span className="text-bold sub-contents-line-height pr-2">
                                        대표이사 :
                                    </span>
                                    이건택
                                </li>
                                <li>
                                    <span className="text-bold sub-contents-line-height pr-2">
                                        설립일자 :
                                    </span>
                                    2000년 4월&nbsp;&nbsp;&nbsp;<span style={{ fontSize: ".9rem" }}>* 모기업 : 하이웨이 시스템 (1991년 설립 ~ 현재)</span>
                                </li>
                                <li>
                                    <span className="text-bold sub-contents-line-height pr-2">
                                        회사주소 :
                                    </span>
                                    경기도 하남시 미사대로 520 한강미사 2차 C동 713호
                                </li>
                            </ul>

                        </p>

                        <p className="pt-4 animated animatedFadeInUp fadeInUp">
                            <span className="text-bold">㈜인트라밴</span>은 1991년 이후 오직 자동차정비업 관련 프로그램을 전문으로 개발하여 온 <span className="text-bold">하이웨이 시스템</span>이
                            IT 전문 플랫폼 비즈니스를 목적으로 설립한 법인입니다.
                        </p>
                    </div>
                </div>
            </div>

            <div className="w-100 ">
                <div className="container">
                    <div className="row">
                        <div className="col-1"></div>
                        <div className="col-sm-10 col-md-10 col-lg-10 text-center">
                            <VisibilitySensor
                                scrollCheck={true}
                                onChange={onVisibilityChangeText01}
                                delayedCall
                            >
                                <p
                                    className={`opacity-0 ${bottomTxtAnimation01 === "1"
                                        ? "animated animatedFadeInUp fadeInUp"
                                        : ""
                                        }`}
                                >
                                    ㈜인트라밴은 <span className="text-bold">모바일 개발팀, 인공지능 AI팀, 데이터 개발팀</span> 등을 활발하게 가동하는 유일한 회사입니다.<br />
                                    나아가 2024년부터는 <span className="text-bold">인공지능 AI 기술</span>을 정비업계 전산에서 최초로 솔루션에 도입하였습니다.
                                </p>
                            </VisibilitySensor>

                            <img
                                src="../assets/img_ebusiness.png"
                                alt=""
                                className="pt-9 pb-9 img-fluid"
                            />
                        </div>
                        <div className="col-1"></div>
                    </div>
                </div>
            </div>

            <div className="w-100 pb-99">
                <div className="container">
                    <div className="row">
                        <div className="col-1"></div>
                        <div className="col-sm-10 col-md-10 col-lg-10 text-center">
                            <VisibilitySensor
                                scrollCheck={true}
                                onChange={onVisibilityChangeText02}
                                delayedCall
                            >
                                <p
                                    className={`opacity-0 ${bottomTxtAnimation02 === "1"
                                        ? "animated animatedFadeInUp fadeInUp"
                                        : ""
                                        }`}
                                >
                                    하지만 인트라밴은 이에 자만하지 않고 앞으로 더욱 분발하여 <span className="text-bold">하이웨이</span>를 사용하는 고객을 위하여<br />
                                    앞으로 최고 레벨의 <span className="text-bold">품질</span>과 <span className="text-bold">서비스</span>가 되도록 최선을 다하겠습니다.
                                </p>
                            </VisibilitySensor>

                            <VisibilitySensor
                                scrollCheck={true}
                                onChange={onVisibilityChangeText03}
                                delayedCall
                            >
                                <p
                                    className={`ceo-sign pt-6 opacity-0 ${bottomTxtAnimation03 === "1"
                                        ? "animated animatedFadeInUp fadeInUp"
                                        : ""
                                        }`}
                                >
                                    대표이사&nbsp;&nbsp;&nbsp;<span>이건택</span>
                                </p>
                            </VisibilitySensor>
                        </div>
                        <div className="col-1"></div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Intro;
